import apiClient, { extractData } from "./client";

export async function getCustomSchedules() {
  const response = await apiClient.get("/custom-schedules");
  return extractData(response);
}

export async function getCustomScheduleByEmployee(employeeId) {
  const response = await apiClient.get(`/custom-schedules/${employeeId}`);
  return extractData(response);
}

export async function createCustomSchedule(data) {
  const response = await apiClient.post("/custom-schedules", data);
  return extractData(response);
}

export async function updateCustomSchedule(employeeId, data) {
  const response = await apiClient.patch(`/custom-schedules/${employeeId}`, data);
  return extractData(response);
}

export async function deleteCustomSchedule(employeeId) {
  const response = await apiClient.delete(`/custom-schedules/${employeeId}`);
  return extractData(response);
}
